import api from "./index";
import { ENDPOINTS } from "./endpoints";

/**
 * Preview a coupon against the current cart without persisting it.
 */
export const validateCoupon = (code) => {
    return api.post(ENDPOINTS.COUPON.VALIDATE, { code });
};

/**
 * Apply a coupon to the cart. Returns the recalculated cart.
 */
export const applyCoupon = (code) => {
    return api.post(ENDPOINTS.COUPON.APPLY, { code });
};

/**
 * Remove the applied coupon from the cart. Returns the recalculated cart.
 */
export const removeCoupon = () => {
    return api.delete(ENDPOINTS.COUPON.REMOVE);
};
